// Wraps a reference fetch so a 401 produces a "forbidden placeholder" instead
// of bubbling up to the global interceptor (which would trigger signoutRedirect).
//
// Callers should also pass { tolerate401: true } in the axios config of the
// wrapped request so the interceptor does not redirect on 401.
//
// On 401: resolves with { status: 200, forbidden: true, data: { ...fallback, forbidden: true } }
//   - status: 200 keeps the entry past existing filterEmptyDocuments(...)
//   - forbidden: true flag is preserved through normalizers and consumed by UI
// On any other error: resolves with null (matches existing getDocumentSafeUrl semantics)
const buildForbiddenResponse = (fallback) => ({
  status: 200,
  forbidden: true,
  data: { ...(fallback ?? {}), forbidden: true },
});

export function safeReferenceRequest(promise, fallback) {
  return new Promise((resolve) => {
    promise
      .then(resolve)
      .catch((error) => {
        if (error?.response?.status === 401) {
          resolve(buildForbiddenResponse(fallback));
          return;
        }
        resolve(null);
      });
  });
}
